import axios from "axios";
import React from "react";

interface ILevel {
  id: number;
  name: string;
}

export default function useLevels(): [Map<number, string>, boolean] {
  const [levels, setLevels] = React.useState<Map<number, string>>(
    new Map()
  );
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<ILevel[]>("/levels/")
      .then((response) => {
        setLevels(new Map(response.data.map((x) => [x.id, x.name])));
        setLoading(false);
      })
      .catch((error) => { console.error(error); setLoading(false); });
  }, []);

  return [levels, loading];
}
